module.exports = __webpack_public_path__ + "static/websites_menu-24d9a33ac619057095c09ce7b248bdee.png";